import { defineStore } from "pinia";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";

export const useQuantityFieldStore = defineStore("quantityfield", {
  state: () => ({
    quantityField: 1
  }),

  getters: {
    getQuantityField(state) {
      const webproductStore = useWebproductStore();
      if (
        webproductStore.getQuantitySelection &&
        webproductStore.getQuantitySelection != ""
      ) {
        var qts = webproductStore.getQuantitySelection.split(",");
        if (qts.includes(state.quantityField)) {
          return state.quantityField;
        } else {
          return qts[0];
        }
      }
      return state.quantityField;
    }
  },

  actions: {
    setQuantityField(payload) {
      const webproductStore = useWebproductStore();
      const changeOptionsStore = useChangeOptionsStore();
      this.quantityField = payload;

      if (webproductStore.getPersonalizationQuantityWithPrice) {
        return;
      }
      changeOptionsStore.setQuantity({ qty: payload, qtyCode: payload });
    }
  }
});
